__turbopack_context__.v({
  "caption": "GridBlock-module__FVUZNG__caption",
  "col": "GridBlock-module__FVUZNG__col",
  "grid1Col": "GridBlock-module__FVUZNG__grid1Col",
  "grid2Col": "GridBlock-module__FVUZNG__grid2Col",
  "grid3Col": "GridBlock-module__FVUZNG__grid3Col",
  "grid4Col": "GridBlock-module__FVUZNG__grid4Col",
  "innerPadding": "GridBlock-module__FVUZNG__innerPadding",
  "noGap": "GridBlock-module__FVUZNG__noGap",
  "responsiveGap": "GridBlock-module__FVUZNG__responsiveGap",
  "smallGap": "GridBlock-module__FVUZNG__smallGap",
});
